import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
export function useCurrentTime() {
  const $ = _c(2);
  const [currentTime, setCurrentTime] = useState(_temp);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const update = () => setCurrentTime(new Date());
      const intervalId = setInterval(update, 60000);
      return () => clearInterval(intervalId);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return currentTime;
}
function _temp() {
  return new Date();
}